import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-public-page',
  templateUrl: './public-page.component.html',
  styleUrls: ['./public-page.component.less']
})
export class PublicPageComponent implements OnInit {
  @Input() pageCaption = '';
  logo: string = '';
  constructor() {
      this.logo = '/img/' + environment.language.toLowerCase() + '/logo.png';
  }

  ngOnInit(): void {
  }

}
